var path = '/templates/projects.analytics/views/show.html';
var html = "<div class=content id=analytics><div class=container><campaign-filter-view filters=filters hide-search-term=true project=currentProject update=updateFilters() reset=resetFilters()></campaign-filter-view><total-stats filters=updatedFilters project=currentProject></total-stats><main-chart filters=updatedFilters project=currentProject></main-chart><pie-chart filters=updatedFilters project=currentProject></pie-chart></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.analytics/views/show.html
// module id = 1337
// module chunks = 0